import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { getFamilyMemberSort, IFamilyMember } from 'src/app/model/contract/IContract';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { INavigationItem } from '../../../../model/sitefinity/INavigationItem';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-family-summary',
  templateUrl: './family-summary.component.html',
  styleUrls: ['./family-summary.component.scss']
})
export class FamilySummaryComponent implements OnChanges {
  @Input() disableAccount: boolean = false;
  @Input() familyMembers: IFamilyMember[] = [];
  @Input() primaryEmail: string = '';
  @Input() loggedInUserEmail: string = '';
  @Input() enableNewVersion: boolean = false;
  @Input() familyManagementLink: INavigationItem;
  thresholdMembers = 5;

  constructor(
    public breakpointObserver: BreakpointObserver, 
    private resourceService: ADPResourceService) {
    breakpointObserver.observe([
      Breakpoints.XSmall,
      '(max-width: 768px)'
    ]).subscribe(result => {
      if (result.matches) {
        this.thresholdMembers = parseInt(this.resourceService.getViewLabel('Global_More_FamilyMember_Threshold_Small'));
      } else {
        this.thresholdMembers = parseInt(this.resourceService.getViewLabel('Global_More_FamilyMember_Threshold_Big'));
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.familyMembers?.currentValue) {
      if (this.enableNewVersion) {
        const arr = [
          ... this.familyMembers.filter(x => x.emailAddress === this.loggedInUserEmail),
          ... this.familyMembers.filter(x => x.emailAddress !== this.loggedInUserEmail)
        ];
        this.familyMembers = arr;
      } else {
        this.familyMembers.sort(getFamilyMemberSort(this.primaryEmail, this.loggedInUserEmail));
      }
    } else {
      this.familyMembers = [];
    }
  }
}
